import { render, staticRenderFns } from "./CustomDomain.vue?vue&type=template&id=082bcf84&"
import script from "./CustomDomain.vue?vue&type=script&lang=js&"
export * from "./CustomDomain.vue?vue&type=script&lang=js&"
import style0 from "./CustomDomain.vue?vue&type=style&index=0&id=082bcf84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports